import React, { useState } from 'react';
import SectionWrapper from './SectionWrapper';
import './ContactSection.css';
import { FaLinkedin, FaGithub, FaYoutube } from 'react-icons/fa';
import emailjs from '@emailjs/browser';


const ContactSection = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.send(
      'service_f48a3ka',
      'template_v68uuxn',
      {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
      },
      'BuBg7EUYM7gqwvB7j'
    )
    .then(() => {
      alert('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' });
    })
    .catch((error) => {
      console.error('EmailJS error:', error);
      alert('Message failed to send.');
    });
  };

  return (
    <>
      <SectionWrapper index={4}>
        <h2 className="section-title">Contact</h2>
        <p className="contact-message">
          Ready to teleport into my world? Drop me a message. 
        </p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <button type="submit" className="contact-submit">Teleport</button>
        </form>

        <div className="social-icons">
          <a href="https://www.linkedin.com/in/sak6m" target="_blank" rel="noreferrer">
            <FaLinkedin />
          </a>
          <a href="https://github.com/SaK6m" target="_blank" rel="noreferrer">
            <FaGithub />
          </a>
          <a href="https://www.youtube.com/@SaK6m" target="_blank" rel="noreferrer">
            <FaYoutube />
          </a>
        </div>
      </SectionWrapper>

      <footer className="site-credit">
        {/* Design, concept and creativity by Saksham. Coded with <span className="heart">❤️</span> and ChatGPT. */}
        Design, concept and creativity by Saksham. Coded with ChatGPT.
      </footer>
    </>
  );
};

export default ContactSection;
